<template>
  <div class="vg_wrapper" v-loading='isLoading'>
    <div class="vd_edhea">
      <editHeader
        :isShow="isShow"
        :btn="btn"
        :strForm="msotForm"
        @openEdit="openEdit"
        @closeEdit="closeEdit"
        @submit="submit('msotForm')"/>
      <el-button type="primary" size="small" class="vd_export" @click="buttonRefresh()" v-if="isShow">刷新</el-button>
    </div>
    <el-form ref="msotForm" :rules="rules" :model="msotForm" :disabled="isShow" label-width="120px" size="mini">
      <el-row>
        <el-col :md="8">
          <el-form-item label="出库编号" prop="msot_no">
            <el-input v-model="msotForm.msot_no" maxlength="10"  show-word-limit placeholder="请填写出库编号">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item label="出库时间" prop="msot_time">
            <el-date-picker
              v-model="msotForm.msot_time"
              type="date"
              placeholder="选择出库时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="vg_button">
        <el-button type="primary" plain size="small" @click="addRow(0)">导入物料待出库</el-button>
        <el-button type="primary" plain size="small" @click="addRow(1)">导入物料</el-button>
        <el-button type="danger" plain size="small" @click="delBank()">删除</el-button>
      </div>
      <el-row class="vd_mrt">
        <MsotAddEditIn @handleSelectionChange="handleSelect" :msotForm="msotForm"></MsotAddEditIn>
      </el-row>
      <el-dialog
          :title="title"
          :visible.sync="notice"
          width="70%">
        <MsotAddEditMpot @confirmIn="confirmIn" ref="MsotAddEditMpot"></MsotAddEditMpot>
      </el-dialog>
      <el-dialog
          :title="title"
          :visible.sync="notice1"
          width="70%">
        <MsotAddEditMtrl @confirmIn="confirmIn" ref="MsotAddEditMtrl"></MsotAddEditMtrl>
      </el-dialog>
      <el-row class="vg_mt_16 vd_bortop">
        <el-col>
          <inputUser :isCookie="true" ref="userData" :stffForm="stffForm" v-if="msotForm.stff_name"></inputUser>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {get,post} from "@api/request";
import editHeader from "@/views/component/editHeader";
import inputUser from "@/views/component/inputUser";
import MsotAddEditMpot from "@/views/StockManagement/MsotManage/TabChild/Component/MsotAddEditMpot";
import MsotAddEditMtrl from "@/views/StockManagement/MsotManage/TabChild/Component/MsotAddEditMtrl";
import MsotAddEditIn from "@/views/StockManagement/MsotManage/TabChild/Component/TabPanel/MsotAddEditIn";
import {msotAPI} from "@api/modules/msot";
export default {
  name: "MsotAddMain",
  components: {
    editHeader,
    inputUser,
    MsotAddEditIn,
    MsotAddEditMpot,
    MsotAddEditMtrl,
  },
  data(){
    return{
      msotForm:{},
      rules:{
        msot_no:[
          { required: true, trigger: 'blur' , message: ' '},
        ],
        msot_time:[
          { required: true, trigger: 'blur' , message: ' '},
        ],
      },
      removeList:[],
      stffForm:{
        stff_name:'',
        cptt_name:'',
        dept_name:'',
        dept_team_name:'',
        stff_id:Number,
        cptt_id:Number,
        dept_id:Number,
        dept_team_id:Number,
      },
      msotList:[],
      copyForm:[],
      notice:false,
      title:'',
      notice1:false,
      isShow: true,
      btn:{},
      isLoading:false 
    }
  },
  created() {
    this.initData()
  },
  methods:{
    initData(){
      this.getList()
     },
     //启用编辑
    openEdit(){
      this.isShow = false;
      this.$emit('isShow',this.isShow)
    },
    //撤销编辑
    closeEdit(){
      this.$confirm('是否撤销编辑?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.initData()
        this.isShow = true
        this.$emit('isShow',this.isShow)
        this.$message({
          type: 'info',
          message: '已撤销编辑!'
        })
      }).catch(()=>{});
    },
    //提交表单
    submit(formName){
      this.$confirm('确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.saveInfo()
          } else {
            console.log('error submit!');
            return false;
          }
        });
      }).catch(()=>{})
    },
    //保存
    saveInfo() {
      let msotForm = {};
      msotForm = Object.assign(msotForm,this.msotForm);
      msotForm.msot_time = (new Date(msotForm.msot_time)).getTime() / 1000;
      let arr = this.msotForm.msot_mtrl_list;
      let bbj = this.helper.deleteSaveBody(this.msotForm,arr,this.copyForm,1);
      msotForm.msot_mtrl_list = msotForm.msot_mtrl_list.concat(bbj) ;
      this.isLoading = true 
      post(msotAPI.editMsot,msotForm)
          .then(res => {
            if(res.data.code === 0){
              this.$message({
                type:'success',
                message:'保存成功'
              })
              this.isShow = true;
              this.$emit('isShow',this.isShow)
              this.initData()
            }else if(res.data.code === 7){
              this.$message({
                type:'error',
                message:'出库编号重复'
              })
              // this.msotForm.msot_time = (new Date(this.msotForm.msot_time)).getTime() * 1000;
            } else {
              let mg = res.data.msg;
              let tp = 'error';
              this.$message({message: mg, type: tp});
              // this.msotForm.msot_time = (new Date(this.msotForm.msot_time)).getTime() * 1000;
            }
            setTimeout(()=>{
              this.isLoading = false 
            },500)
          }).catch((res) =>{
            let msg = res.data.msg 
            this.$message.error(msg)
          })
    },
    //取消
    cancel(){
      this.$confirm('确定取消新增?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.resetForm('msotForm')
        this.$router.go(-1)
        this.$message({
          type: 'info',
          message: '已取消新增!'
        });
      }).catch(()=>{})
    },
    // 刷新按钮
    buttonRefresh(){
      this.isLoading = true 
      this.initData()
    },
    //删除选择的内容
    handleSelect(val){
      this.removeList = val;
    },
    // 删除物料信息按钮
    delBank(){
      for(let i=0;i<this.removeList.length;i++){
        if(this.msotForm.msot_mtrl_list.indexOf(this.removeList[i]) !== -1){
          let index = this.msotForm.msot_mtrl_list.indexOf(this.removeList[i]);
          this.msotForm.msot_mtrl_list.splice(index,1)
        }
      }
    },
    // 打开导入物料信息小窗口
    addRow(num){
      if(num === 0){
        this.notice = true;
      }else if(num === 1){
        this.notice1 = true;
      }
    },
    // 导入小窗口确定按钮
    confirmIn(val){
      console.log('val',val)
      this.notice = false;
      this.notice1 = false;
      if(val.length>0){
        this.msotList = val;
        let msotListCopy = [];
        for(let i=0;i<this.msotList.length;i++){
          let temp = {};
          if(this.msotList[i].mpot_id){
            temp.mpot_id = this.msotList[i].mpot_id;
            temp.stay_mpot_num = parseInt(this.msotList[i].mtrl_num)-parseInt(this.msotList[i].mpot_num);
          }
          temp.mtrl_id = this.msotList[i].mtrl_id;
          temp.mtrl_no = this.msotList[i].mtrl_no;
          temp.mtrl_name = this.msotList[i].mtrl_name;
          temp.mtrl_unit = this.msotList[i].mtrl_unit;
          msotListCopy.push(temp)
        }
        this.msotForm.msot_mtrl_list = this.msotForm.msot_mtrl_list.concat(msotListCopy);
        if(this.msotList[0].mpot_id){
          this.$refs.MsotAddEditMpot.clear()
        }else{
          this.$refs.MsotAddEditMtrl.clear()
        }
      }
    },
    // 获取信息步骤
    getList(){
      let msot_id = this.$route.query.form_id
      get(msotAPI.getMsotById,{msot_id:msot_id})
      .then(res=>{
        if (res.data.code === 0) {
           // 权限按钮
          this.btn = res.data.data.btn;
          this.msotForm = res.data.data.form;
          this.getInputUser()
          this.msotForm.msot_time = this.msotForm.msot_time*1000;
          this.copyForm = Object.assign(this.copyForm,this.msotForm.msot_mtrl_list)
        }
        setTimeout(()=>{
          this.isLoading = false 
        },500)
      })
      .catch(res => {
        let mg = res.data.msg;
        let tp = 'error';
        this.$message({message: mg, type: tp});
      })
    },
    //获取录入人
    getInputUser(){
      this.stffForm.cptt_id = this.msotForm.cptt_id;
      this.stffForm.user_id = this.msotForm.user_id;
      this.stffForm.dept_id = this.msotForm.dept_id;
      this.stffForm.stff_id = this.msotForm.stff_id;
      this.stffForm.dept_name = this.msotForm.dept_name;
      this.stffForm.dept_team_id = this.msotForm.dept_team_id;
      this.stffForm.dept_team_name = this.msotForm.dept_team_name;
      this.stffForm.stff_name = this.msotForm.stff_name;
    },
    //表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.msotForm.msot_mtrl_list = [];
    },
  }
}
</script>

<style scoped lang="scss">
.vd_mrt{
  margin-top: 20px;
}
.vd_bortop {
  border-top: #DCDFE6 solid 1px;
  padding-top: 20px;
}
.vd_edhea{
  position: relative;
}
.vd_export{
  position: absolute;
  top: 0;
  left: 65px;
}
</style>